export function formatNumber(n: number | null | undefined): string {
  if (n === null || n === undefined || isNaN(n)) return '-';
  return n.toLocaleString('en-US');
}

/** Short axis label: 12,400 → "12K". */
export function formatCompact(n: number): string {
  return new Intl.NumberFormat('en-US', { notation: 'compact', maximumFractionDigits: 1 }).format(n);
}

export function cellDisplay(n: number | null | undefined): string {
  if (n === null || n === undefined) return '-';
  return formatNumber(n);
}

export function fmtDateInput(d: string | Date | null | undefined): string {
  if (!d) return '';
  const t = typeof d === 'string' ? new Date(d) : d;
  if (isNaN(t.getTime())) return '';
  const y = t.getFullYear();
  const m = String(t.getMonth() + 1).padStart(2, '0');
  const day = String(t.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function fmtDateDisplay(d: string | Date | null | undefined): string {
  if (!d) return '';
  const t = typeof d === 'string' ? new Date(d) : d;
  if (isNaN(t.getTime())) return '';
  return fmtDateInput(t);
}

export function parseNullableIntCell(raw: string): number | null | { error: string } {
  const s = (raw || '').trim();
  if (s === '' || s === '-') return null;
  const n = Number(s.replace(/,/g, ''));
  if (isNaN(n) || !isFinite(n)) return { error: `Must be an integer >= 0 or "-"` };
  if (n < 0) return { error: `Must be >= 0 or "-"` };
  if (!Number.isInteger(n)) return { error: `Must be an integer` };
  return n;
}

// 13 distinct color hues for the 13 counties, picked to be readable on a
// white background and distinct enough for a line chart legend.
export const USAJILI_COUNTY_COLORS: Record<string, string> = {
  Baringo: '#4E79A7',
  Bomet: '#F28E2B',
  Bungoma: '#E15759',
  'Elgeyo Marakwet': '#76B7B2',
  Kericho: '#59A14F',
  Nakuru: '#EDC948',
  Nandi: '#B07AA1',
  Narok: '#FF9DA7',
  Samburu: '#9C755F',
  'Trans Nzoia': '#BAB0AC',
  Turkana: '#1F77B4',
  'Uasin Gishu': '#A0CBE8',
  'West Pokot': '#8CD17D',
};

export function countyColor(county: string): string {
  return USAJILI_COUNTY_COLORS[county] || '#666666';
}
